import React from 'react'
import { Select, TextInput, EmailInput, FormLabel, FormError, Option } from "@components";
import { FormGroup } from "../components";

const TeamMemberForm = ({editing, handleSubmit, onSubmit, control, errors, branches, roles, hasBranches}) => (
  <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-y-6">
    <FormGroup>
      <FormLabel>Name</FormLabel>
      <TextInput
        displayName="Name"
        control={control}
        required
        name="name"
        placeholder=""
        errors={errors.name}
      />
      <FormError name="name" errors={errors} />
    </FormGroup>
    <FormGroup>
      <FormLabel>Email address</FormLabel>
      <EmailInput
        displayName="Email address"
        control={control}
        required
        name="email"
        placeholder=""
        errors={errors.email}
        disabled={editing}
      />
      <FormError name="email" errors={errors} />
    </FormGroup>
    <FormGroup>
      <FormLabel>Role</FormLabel>
        <Select
          name="roleId"
          displayName="Role"
          control={control}
          required
          placeholder="Select a role for this member"
          errors={errors.roleId}
        >
          {roles.map((x, i) => <Option key={i} value={x.value}>{x.display}</Option>)}
        </Select>
      <FormError name="roleId" errors={errors} />
    </FormGroup>
    {hasBranches && (
      <FormGroup>
        <FormLabel>Branch</FormLabel>
          <Select
            name="branchId"
            displayName="Branch"
            control={control}
            placeholder="Assign this member to a branch"
            errors={errors.branchId}
          >
            {branches.map((x, i) => <Option key={i} value={x.value}>{x.display}</Option>)}
          </Select>
        <FormError name="branchId" errors={errors} />
      </FormGroup>
    )}
  </form>
)

export default TeamMemberForm